import ComparisonChip from "../UI/chips/ComparisonChip";
import comparisonUtil from "../../utils/comparisonUtil";

const KpiComparisonContinuity = ({
  value,
  compareValue,
  variant,
}: {
  value: number;
  compareValue: number;
  variant?: "chip" | "icon";
}) => (
  <ComparisonChip
    positiveIndicator="POSITIVE"
    value={comparisonUtil.getRoundedComparison(value, compareValue)}
    id={compareValue}
    variant={variant}
  />
);

export default KpiComparisonContinuity;
